import { render, staticRenderFns } from "./InviteMember.vue?vue&type=template&id=3b450db2&scoped=true&"
import script from "./InviteMember.vue?vue&type=script&lang=js&"
export * from "./InviteMember.vue?vue&type=script&lang=js&"
import style0 from "./InviteMember.vue?vue&type=style&index=0&id=3b450db2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b450db2",
  null
  
)

export default component.exports